export enum PaymentTablesColumns {
    Type = 'Type',
    Identifier = 'Identifier',
    Created = 'Created',
    Cashier = 'Cashier',
    Bill = 'Bill',
    Notes = 'Notes',
    Status = 'Status',
    Amount = 'Amount',
    Actions = 'Actions',
    Reservation = 'Reservation',
}

export enum PaymentsTabActiveSegment {
    Overview = 'Overview',
    Requests = 'Requests',
    Methods = 'Methods',
    Plans = 'Plans',
}
